module.exports = __webpack_public_path__ + "img/bbshomepage8.56cbd86c.png";